import { Select, SelectOption } from "@clockwise/design-system";
import { default as React } from "react";

export const TimeSuggestionsSearchTimeRangePicker = () => {
  const [options, _setOptions] = React.useState([
    {
      label: "ASAP",
      value: "ASAP",
    },
    {
      label: "Within 7 days",
      value: "Within 7 days",
    },
    {
      label: "Today",
      value: "Today",
    },
    {
      label: "Tomorrow",
      value: "Tomorrow",
    },
    {
      label: "Later this week",
      value: "Later this week",
    },
    {
      label: "Next week",
      value: "Next week",
    },
    {
      label: "Within some days",
      value: "Within some days",
    },
    {
      label: "From",
      value: "From",
    },
    {
      label: "On",
      value: "On",
    },
    {
      label: "Around",
      value: "Around",
    },
    {
      label: "Before",
      value: "Before",
    },
    {
      label: "After",
      value: "After",
    },
  ]);

  // React.useEffect(() => {
  //   if (options.indexOf(currentDuration) === -1) {
  //     setOptions([...options, currentDuration].sort());
  //   }
  // }, [currentDuration]);

  const onSelect = (value: number) => {
    console.log(value);
  };

  return (
    <Select size="small" variant="default" value={undefined} onChange={onSelect}>
      {options.map((option) => {
        return (
          <SelectOption key={option.label} value={option.value}>
            {option.label}
          </SelectOption>
        );
      })}
    </Select>
  );
};
